import Navbar from "../../NavBar/Navbar"
import SideBar from "../../NavBar/Sidebar"
import CrearResumenGuiaContent from "./CrearResumenGuiaContent"

interface ChildsProps {
    logout: () => void
}
const CrearResumenGuia: React.FC<ChildsProps> = ({logout})=> {
    return(
    <div className="sidebar-noneoverflow">
        <Navbar logout={logout}/>
        <div className="main-container" id="container">
            <SideBar/>
            <CrearResumenGuiaContent/>
        </div>

    </div>
    )
}


export default CrearResumenGuia